import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import api from "@/lib/api";
import { LanguageProvider } from "@/lib/i18n";
import { AdminAuthProvider } from "@/lib/auth";
import Masthead from "@/components/Masthead";
import AiChat from "@/components/AiChat";
import Ticker from "@/components/Ticker";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import ArticlePage from "@/pages/ArticlePage";
import SearchPage from "@/pages/SearchPage";
import DistrictsPage from "@/pages/DistrictsPage";
import DistrictPage from "@/pages/DistrictPage";
import EpaperPage from "@/pages/EpaperPage";
import AdminPage from "@/pages/AdminPage";
import InfoPage from "@/pages/InfoPage";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function TickerBar() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api
      .get("/ticker")
      .then((r) => setItems(r.data.items))
      .catch(() => {});
  }, []);
  return <Ticker items={items} />;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <AdminAuthProvider>
        <BrowserRouter>
          <ScrollTop />
          <Masthead />
          <TickerBar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/section/:id" element={<CategoryPage />} />
              <Route path="/article/:id" element={<ArticlePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/districts" element={<DistrictsPage />} />
              <Route path="/district/:id" element={<DistrictPage />} />
              <Route path="/epaper" element={<EpaperPage />} />
              <Route path="/p/:slug" element={<InfoPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
          <AiChat />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AdminAuthProvider>
    </LanguageProvider>
  );
}

export default App;
